import {BASIC_SET_ME} from "../../constants/store";

export const me = (state = null, action) => {
  switch (action.type) {
    case BASIC_SET_ME:
      return action.payload === null ? null : Object.assign({}, action.payload);
    default:
      return state
  }
};